<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-1">
          <div class="col-xl-5 col-12 col-sm-6 
          col-md-6">
            <div class="w-100 d-inline-block margin-top-4 mt-3">
              <p class="mb-0 text-size-15 nav-color family-filson-bold text-uppercase text-full-15 margin-xl-top-3">
                Taste of the wild
              </p>
              <h2 class="half-black fw-bold fs-2 family-filson-bold text-xs-size-19 text-full-28 margin-xl-bottom-3 mt-xl-0 mt-2"> Hottest Savings Have 
              Arrived! </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-12 mt-xl-0 mt-2">
                If you're getting a new dog, you're going to need things like a leash, collar, and crate, so we've put together a list of supplies for new.
              </p>
              <div class="w-100 d-inline-block margin-top-4">
                <a class="text-white text-size-14 d-inline-block text-uppercase bg-online-book bg-green inter-semi-bold mb-sm-4 mb-xl-0 text-full-11 w-xs-100 text-xs-center" href="javascript:void(0)">
                  <i class="fa fa-shopping-cart me-2 text-full-15 text-size-17" aria-hidden="true"></i>
                  Shop Now
                </a>
              </div>
            </div>
          </div>
          <div class="col-xl-7 col-12 col-sm-6 
          col-md-6">
            <div class="w-100 d-inline-block mt-xl-0 
            mt-4">
              <img class="w-100" v-lazy="require('@/assets/images/pet-grooming-grooming-services.webp')" alt="pet grooming, grooming services">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'petsProteenComponent',
}
</script>

<style scoped>

</style>
